import { FC, useState, useEffect } from "react";
import useGridFilter from "../../../../system/hooks/useGridFilter";
import { useAppContext } from "../../../../system/providers/appContextProvider";
import { DefaultGrid } from "../../../../components/grids/default/defaultGrid";
import { usePluginContext } from "../../../../system/providers/plugin";
import { LoadingStatus, } from "../../../../@types/enumsGlobal";
import { ToolbarWrapper } from "../../../../components/plugins/ToolbarWrapper";
import { DefaultPricingModelCommandsPanel } from "../../../../components/commandsPanels/DefaultPricingModelCommandsPanel";
import { PricingConditionDataProvider } from "../../../../Services/DataProviders/PricingConditionDataProvider";
import { IPricingConditionViewDTO, IPricingConditionDTO } from "../../../../libs/coreapi-dto/dirs/pricingCondition";
import { IPricingPriceCalcSchemaDTO, IPricingPriceCalcSchemaViewDTO } from "../../../../libs/coreapi-dto/dirs/pricingPriceCalcSchema";
import { PricingPriceCalcSchemaDataProvider } from "../../../../Services/DataProviders/PricingPriceCalcSchemaDataProvider";
import { PricingPriceCalcSchemaCreatorModal } from "../selectorModal/PricingPriceCalcSchemaCreatorModal";
import { PricingFormulaCreatorModal } from "../selectorModal/PricingFormulaCreatorModal";
import { IPricingAdpriceScaleTypeDTO, IPricingAdpriceScaleTypeViewDTO } from "../../../../libs/coreapi-dto/dirs/pricingAdpriceScaleType";
import { PricingPriceCalcSchemaTypeDataProvider } from "../../../../Services/DataProviders/PricingPriceCalcSchemaTypeDataProvider";


export interface ICopyGridProps extends ISelectorGridProps {
    gridId: string,
    plugin: IPluginSettings,
    baseGridFilter?: IGridFilter,
    id?: string,
    selectedCalcSchemaTypeObject?: IPricingAdpriceScaleTypeViewDTO;
}
export interface IPricingPriceCalcSchemaDTOAndIdGlobal extends IPricingPriceCalcSchemaDTO {
    idPricingPriceCalcSchemaGlobal?: string
}

interface IModalStateProps {
    isOpen: boolean,
    modalData: IPricingPriceCalcSchemaDTOAndIdGlobal,
    variant: "create" | "edit" | "copy";
    idCalcSchemaDefaultGlobal?: string
}

export const initialPricingPriceCalcSchema: IPricingPriceCalcSchemaDTOAndIdGlobal = {
    name: '',
    description: '',
    conditionMethod: 'И',
    idPricingPriceCalcSchemaTypeGlobal: '',
    idPricingPriceCalcSchemaGlobal: '',
}

export const PricingPriceCalcSchemaGrid: FC<ICopyGridProps> = (props) => {

    const pluginCtx = usePluginContext();
    const appCtx = useAppContext()
    const pricingPriceCalcSchemaDP = new PricingPriceCalcSchemaDataProvider(appCtx.coreApiService)
    const pricingConditionDataProvider = new PricingConditionDataProvider(appCtx.coreApiService)
    const pricingPriceCalcSchemaTypeDP = new PricingPriceCalcSchemaTypeDataProvider(appCtx.coreApiService);

    const [data, setData] = useState<IPricingPriceCalcSchemaViewDTO[]>([]);
    const [loadingStatus, setLoadingStatus] = useState<LoadingStatus>();
    const [totalCount, setTotalCount] = useState(0);
    const [viewState, setViewState] = useState<GridStateType>("view");
    const [gridFilter, dispatchGridFilter] = useGridFilter(props.baseGridFilter);
    const [selectedItem, setSelectedItem] = useState<IGridRow>();
    const [blockButton, setBlockButton] = useState<boolean>(true);
    const [currentDefaultId, setCurrentDefaultId] = useState<string | undefined>(undefined);

    const masterGridSelectedItem = pluginCtx.masterGrid.selectedItem?.idGlobal;

    useEffect(() => {
        getView();
    }, [masterGridSelectedItem, gridFilter])

    const [modalState, setModalState] = useState<IModalStateProps>({
        isOpen: false,
        modalData: initialPricingPriceCalcSchema,
        variant: 'create',
        idCalcSchemaDefaultGlobal: currentDefaultId      
    });

    const [modalFormula, setModalFormula] = useState(false);

    const getView = () => {
        if (masterGridSelectedItem) {
            setSelectedItem(undefined);
            pricingPriceCalcSchemaDP.getView({
                ...gridFilter,
                columnFilters: [
                    {
                        name: "idPricingPriceCalcSchemaTypeGlobal",
                        operator: 'Eq',
                        value: masterGridSelectedItem
                    }
                ]
            }, (data, totalCount) => {
                const defaultItem = data.find(item => item.isDefault === true);
                const defaultId = defaultItem?.idGlobal;
                
                setCurrentDefaultId(defaultId);
                setData(data)
                setTotalCount(totalCount)
                data.length > 0 ? setLoadingStatus(LoadingStatus.Completed) : setLoadingStatus(LoadingStatus.NoData)
            })
        }
    }

    
    const variantSaveData = (
        saveData: IPricingPriceCalcSchemaDTO,
        idPricingPriceCalcSchemaGlobal: string | undefined,
        idCalcSchemaDefaultGlobal?: string
    ) => {
       
        const updateDefaultSchema = (callback?: () => void) => {
            if (idCalcSchemaDefaultGlobal) {
                const saveDataCalcSchema: IPricingAdpriceScaleTypeDTO = {
                    name: props.selectedCalcSchemaTypeObject?.name ?? '',
                    description: props.selectedCalcSchemaTypeObject?.description ?? '',
                    idCalcSchemaDefaultGlobal: idCalcSchemaDefaultGlobal
                };

                pricingPriceCalcSchemaTypeDP.update(
                    props.selectedCalcSchemaTypeObject?.idGlobal as string,
                    saveDataCalcSchema,
                    () => {
                        setCurrentDefaultId(idCalcSchemaDefaultGlobal);
                        callback?.();
                    }
                );
            } else {
                callback?.();
            }
        };

        updateDefaultSchema(() => {
            if (idPricingPriceCalcSchemaGlobal) {
                pricingPriceCalcSchemaDP.update(idPricingPriceCalcSchemaGlobal as string, saveData, () => {
                    setModalState(prev => ({ ...prev, isOpen: false }));
                    getView();
                });
            } else {
                pricingPriceCalcSchemaDP.create(saveData, (idGlobal) => {
                    setModalState(prev => ({ ...prev, isOpen: false }));
                    getView();
                });
            }
        });
    }

    const openModal = (variant: "create" | "edit" | "copy", data?: any) => {
        setModalState({
            isOpen: true,
            modalData: data || initialPricingPriceCalcSchema,
            variant: variant,
            idCalcSchemaDefaultGlobal: currentDefaultId
        });
    };


    return (
        <>
            <ToolbarWrapper>
                <DefaultPricingModelCommandsPanel
                    add={{
                        onClick: () => {
                            if (masterGridSelectedItem) {
                                openModal('create', {
                                    ...initialPricingPriceCalcSchema,
                                    idPricingPriceCalcSchemaTypeGlobal: masterGridSelectedItem
                                });
                            }
                        },
                    }}
                    edit={{
                        onClick: () => {
                            if (selectedItem && blockButton) {
                                setBlockButton(false);
                                pricingPriceCalcSchemaDP.getById(selectedItem.idGlobal, async (entity) => {
                                    openModal('edit', {
                                        ...entity,
                                        idPricingPriceCalcSchemaGlobal: selectedItem.idGlobal
                                    });
                                    setBlockButton(true);
                                })
                            }
                        },
                        disabled: !selectedItem
                    }}
                    copy={{
                        onClick: async () => {
                            if (selectedItem && blockButton) {
                                setBlockButton(false);

                                // 1) Получаем копию документа
                                const entityCopy = await new Promise<IPricingPriceCalcSchemaDTO>((resolve) => {
                                    pricingPriceCalcSchemaDP.getById(selectedItem.idGlobal, (entity) => resolve(entity));
                                });
                                const copyEntity = { ...entityCopy, idPricingPriceCalcSchemaGlobal: ''};


                                //2) Получаем все условия вью.
                                const viewDataPricing = await new Promise<IPricingConditionViewDTO[]>((resolve) => {
                                    pricingConditionDataProvider.getView({
                                        ...gridFilter, columnFilters: [{
                                            name: 'idPricingPriceCalcSchemaGlobal',
                                            operator: 'Eq',
                                            value: selectedItem.idGlobal
                                        }]
                                    }, (data) => resolve(data));
                                });


                                if (viewDataPricing.length > 0) {
                                    //3 если есть условия то создаем новую позицию.

                                    const createdIdPricingPriceCalcSchemaGlobal = await new Promise<string>((resolve) => {
                                        pricingPriceCalcSchemaDP.create(copyEntity, (idPricingPriceCalcSchemaGlobalRequest) => {
                                            resolve(idPricingPriceCalcSchemaGlobalRequest);
                                        })
                                    })

                                    //4 Получаем все условия по вьюхе и добавляем новый idScaleGlobal
                                    const promisesCopyConditions = viewDataPricing.map((elemGet) => {
                                        return new Promise<IPricingConditionDTO>((resolve, reject) => {

                                            try {
                                                pricingConditionDataProvider.getById(elemGet.idGlobal, (condition) => {
                                                    resolve({
                                                        compareTypeEnum: condition.compareTypeEnum,
                                                        paramValue: condition.paramValue,
                                                        paramValueGlobal: '00000000-0000-0000-0000-000000000000',
                                                        paramValueChar: condition.paramValueChar,
                                                        paramValueRef: condition.paramValueRef,
                                                        idPricingConditionParamGlobal: condition.idPricingConditionParamGlobal,
                                                        idPricingAdpriceScaleGlobal: condition.idPricingAdpriceScaleGlobal,
                                                        idPricingMinAdpriceSchemaGlobal: condition.idPricingMinAdpriceSchemaGlobal,
                                                        idPricingRoundScaleGlobal: condition.idPricingRoundScaleGlobal,
                                                        idPricingExtremeAdpriceSchemaGlobal: condition.idPricingExtremeAdpriceSchemaGlobal,
                                                        idPricingPriceCalcSchemaGlobal: createdIdPricingPriceCalcSchemaGlobal,
                                                        ids: condition.ids
                                                    });

                                                })
                                            } catch (error) {
                                                reject(error)
                                            }

                                        });
                                    });

                                    try {
                                        const copyConditions = await Promise.all(promisesCopyConditions);
                                        //5 Создаем новую копию условий с новым ScaleIdGlobal
                                        const promisesCreateConditions = copyConditions.map((newCondition) => {
                                            // Проверка объекта на свойство ids, если данный объект не содержит ids значит будет создавать без ids
                                            const { ids, ...newPricingConditionData } = newCondition;
                                            const checkCondition = newCondition.ids === null || newCondition.ids.length === 0 ? newPricingConditionData : newCondition

                                            return new Promise<string>((resolve) => {
                                                pricingConditionDataProvider.create(checkCondition as any, (idGlobal) => {
                                                    resolve(idGlobal);
                                                })

                                            });
                                        });
                                        const createConditions = await Promise.all(promisesCreateConditions);

                                        if (createConditions) {
                                            setBlockButton(true);
                                            openModal('copy', {
                                                ...copyEntity,
                                                idPricingPriceCalcSchemaGlobal: createdIdPricingPriceCalcSchemaGlobal
                                            });
                                        }

                                    } catch (error) {
                                        throw new Error('Ошибка при генерации условий');
                                    }


                                } else {
                                    setBlockButton(true);
                                    setModalState({
                                        isOpen: true,
                                        modalData: {
                                            ...copyEntity,
                                            idPricingPriceCalcSchemaGlobal: ''
                                        },
                                        variant: 'copy'
                                    });
                                }
                            }
                        },
                        disabled: !selectedItem
                    }}
                    delete={{
                        onClick: () => {
                            if (selectedItem && blockButton) {
                                setBlockButton(false);
                                pricingPriceCalcSchemaDP.markDelete(selectedItem.idGlobal, () => {
                                    setBlockButton(true);
                                    getView();
                                });
                            }
                        },
                        disabled: !selectedItem
                    }}
                    refresh={{
                        onClick: () => {
                            getView();
                        }
                    }}
                    formula={{
                        onClick: () => setModalFormula(true),
                        disabled: !selectedItem
                    }}
                    permission={props.plugin.permission}
                />
            </ToolbarWrapper>
            {
                <DefaultGrid
                    gridId={props.gridId}
                    data={data}
                    loadingStatus={loadingStatus}
                    setLoadingStatus={setLoadingStatus}
                    singleDirectory
                    totalCount={totalCount}
                    filter={gridFilter}
                    dataProvider={pricingPriceCalcSchemaDP}
                    plugin={props.plugin}
                    selectedItem={selectedItem}
                    onDoubleClick={(row) => props.onDoubleClick?.(row)}
                    onSelect={(row) => {
                        setSelectedItem(row ? row : undefined)
                        props.onSelect?.(row)
                    }}
                    onSort={(i) => dispatchGridFilter({ type: "sort", payload: i.propertyName })}
                    onFilterDelete={(i) => dispatchGridFilter({ type: "deleteColumnFilter", payload: i.propertyName })}
                    onPageNumberChange={(n) => dispatchGridFilter({ type: "changePageNumber", payload: { pageNumber: n } })}
                    onNumberPerPageChange={(n) => dispatchGridFilter({ type: "changeNumberPerPage", payload: { numberPerPage: n } })}
                    onEnter={() => setViewState("edit")}
                    renderCustomCell={(cell: IGridCell) => {
                        if (cell.propertyName === "isDefault") {
                            return (
                                <input
                                    key={`${cell.propertyName}_${currentDefaultId}`}
                                    type={'checkbox'}
                                    checked={cell.value}
                                    disabled
                                />
                            )
                        }
                        
                        return null;
                    }} 
                />
            }
            {
                modalState.isOpen &&
                <PricingPriceCalcSchemaCreatorModal
                    data={modalState.modalData}
                    idCalcSchemaDefaultGlobal={currentDefaultId || ''}
                    variant={modalState.variant}
                    save={(saveData, idPricingPriceCalcSchemaGlobal, idCalcSchemaDefaultGlobal) => {

                        if (modalState.variant === 'edit') {
                            variantSaveData(saveData, selectedItem?.idGlobal, idCalcSchemaDefaultGlobal)
                        }
                        else if (modalState.variant === 'copy') {
                            variantSaveData(saveData, idPricingPriceCalcSchemaGlobal, idCalcSchemaDefaultGlobal)
                        }
                        else if (modalState.variant === 'create') {
                            variantSaveData(saveData, idPricingPriceCalcSchemaGlobal, idCalcSchemaDefaultGlobal)
                        }
                    }}
                    cancel={() => {
                        if (modalState.variant === 'create' || modalState.variant === 'copy') {
                            getView();
                        }
                        setModalState(prev => ({ ...prev, isOpen: false }))
                    }}
                />
            }
            {modalFormula && selectedItem &&
                <PricingFormulaCreatorModal
                    data={{ idPricingPriceCalcSchemaGlobal: selectedItem.idGlobal }}
                    variant={"edit"}
                    save={() => setModalFormula(false)}
                    cancel={() => setModalFormula(false)}
                />
            }
        </>
    )
}